import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setTooltip } from '@as-react/common-utils';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Chip, StackBlock, TextAlpha } from '@yonderland/andes-react';
import { Grid } from '@as/cotopaxi';
export const ProductVariantButtonsAlpha = ({ productVariants, handleVariantClick, productCode, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    useEffect(() => {
        productVariants.map(({ productCodeVariants }, vIndex) => productCodeVariants.map((_, cIndex) => setTooltip({
            element: `#product-variant-button-${vIndex}-disabled-${cIndex}`,
            content: t('pdp.combination.not.available'),
            showCloseButton: false,
            optionsOverride: {
                placement: 'bottom',
            },
        })));
    }, []);
    return (_jsx(StackBlock, { gap: "2", children: productVariants.map(({ variantType, productCodeVariants }, vIndex) => (_jsxs(StackBlock, { gap: "2", children: [_jsx(TextAlpha, { strong: true, children: `${variantType}:` }), _jsx(Grid, { scalable: {
                        min: `${Math.max(...productCodeVariants.map(code => code.variantValue.length))}ch`,
                        maxCols: productCodeVariants.length <= 2 ? { mobile: 2, desktop: 3 } : { mobile: 4, desktop: 5 },
                        repeatPattern: productCodeVariants.length <= 2 ? 'auto-fill' : undefined,
                    }, gap: "s", dataQA: "product-variant-buttons", children: productCodeVariants.map((variant, cIndex) => {
                        const id = `product-variant-button-${vIndex}-${variant.productCode || `disabled-${cIndex}`}`;
                        return (_jsx(Chip, { testId: id, id: id, text: variant.variantValue, state: !variant.productCode ? 'disabled' : productCode === variant.productCode ? 'activated' : 'resting', strikethrough: !variant.productCode, onClick: variant.productCode && variant.productSeoUrl && productCode !== variant.productCode
                                ? handleVariantClick(variant)
                                : undefined, size: "md", variant: "primary" }, variant.productCode || `${variantType}-${cIndex}`));
                    }) })] }))) }));
};
